<footer>
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <div class="logo-wrapper">
          <img
            src="https://insizon-email-templates-bucket.s3.us-east-2.amazonaws.com/insizon/insizon-logo-v3-png.png"
            alt="Insizon Logo"
            class="footer-logo" />
          <p>
            We are a technology-driven company committed to building impactful
            software solutions that solve real-world problems and transform
            businesses.
          </p>
        </div>
        <section class="m-0 p-0">
          <!-- Facebook -->
          <!-- Replace (click)="showNoSocialMsg()" when have social href="#!" -->
          <a
            data-mdb-ripple-init
            class="btn btn-link btn-floating btn-md text-white"
            role="button"
            (click)="showNoSocialMsg()"
            data-mdb-ripple-color="dark"
            ><i class="fab fa-facebook-f"></i
          ></a>
          <!-- Twitter -->
          <a
            data-mdb-ripple-init
            class="btn btn-link btn-floating btn-md text-white"
            (click)="showNoSocialMsg()"
            role="button"
            data-mdb-ripple-color="dark"
            ><i class="fab fa-twitter"></i
          ></a>
          <!-- Twitter -->
          <a
            data-mdb-ripple-init
            class="btn btn-link btn-floating btn-md text-white"
            (click)="showNoSocialMsg()"
            role="button"
            data-mdb-ripple-color="dark"
            ><i class="fab fa-youtube"></i
          ></a>
          <!-- Twitter -->
          <a
            data-mdb-ripple-init
            class="btn btn-link btn-floating btn-md text-white"
            (click)="showNoSocialMsg()"
            role="button"
            data-mdb-ripple-color="dark"
            ><i class="fab fa-tiktok"></i
          ></a>
          <a
            data-mdb-ripple-init
            class="btn btn-link btn-floating btn-md text-white"
            (click)="showNoSocialMsg()"
            role="button"
            data-mdb-ripple-color="dark"
            ><i class="fab fa-snapchat"></i
          ></a>
        </section>
      </div>
      <div class="col-md-2">
        <div class="nav-group">
          <h6 class="nav-title">Contact</h6>
          <div class="nav-links">
            <a href="mailto:business@insizon.com" class="footer-link">
              Business
            </a>
            <a href="#" class="footer-link"> Instagram </a>
            <a href="#" class="footer-link"> Linkedin </a>
            <a href="#" class="footer-link"> Discource </a>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="nav-group">
          <h6 class="nav-title">Company</h6>
          <div class="nav-links">
            <a href="/careers" class="footer-link"> Careers </a>
            <a href="/about" class="footer-link"> About </a>
            <a href="#" class="footer-link"> Affiliate </a>
            <a href="#" class="footer-link"> Team </a>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="nav-group">
          <h6 class="nav-title">Support</h6>
          <div class="nav-links">
            <a href="#" class="footer-link"> Help Center </a>
            <a href="/bug-logs" class="footer-link"> Bug Reports </a>
            <a href="#" class="footer-link"> Newsletter </a>
            <a href="#" class="footer-link"> Feature Request </a>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="nav-group">
          <h6 class="nav-title">Get in Touch</h6>
          <div class="nav-links">
            <a href="mailto:business@insizon.com" class="footer-link">
              <i class="fa-solid fa-envelope"></i> business&#64;insizon.com
            </a>
            <a href="tel:+1234567890" class="footer-link">
              <i class="fa-solid fa-phone-volume"></i> +1 (234) 567-890
            </a>
            <span class="footer-link">
              <i class="fa-solid fa-location-dot"></i> Dallas, TX, USA
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-container">
        <div class="bottom-content">
          <div class="copyright">
            <p>© {{ year }} Insizon. All rights reserved.</p>
          </div>
          <div class="legal-links">
            <a href="/privacy-policy" class="legal-link">Privacy Policy</a>
            <span class="separator">|</span>
            <a href="/terms-of-services" class="legal-link">Terms of Service</a>
            <span class="separator">|</span>
            <a href="#" class="legal-link">Cookie Policy</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
